import { render, staticRenderFns } from "./UpdateCard.vue?vue&type=template&id=7acd40f9"
import script from "./UpdateCard.vue?vue&type=script&lang=js"
export * from "./UpdateCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports